import React from 'react';

const withBackgroundImage = (className) => (WrappedComponent) => {
  class HOC extends React.Component {
    componentDidMount() {
      document.getElementById("left-container").classList.add(className);
    }
    componentWillUnmount() {
      if (document.getElementById("left-container").classList.contains(className)) {
        document.getElementById("left-container").classList.remove(className);
      }
    }
    render() {
      return (
        <WrappedComponent
          {...this.props}
        />
      );
    }
  }
    
  return HOC; 
}

export default withBackgroundImage;


// WEBPACK FOOTER //
// ./src/HOC/withBackgroundImage.js